import React from 'react';
import PropTypes from 'prop-types';
import { WIDGET_GRID_COPY } from '../../constants';
import WidgetErrorState from '../WidgetErrorState';

/**
 * Error boundary que captura errores en widgets hijos.
 * Si un widget falla, los demas no se ven afectados.
 * El boton Reintentar resetea el boundary para volver a montar el widget.
 */
class WidgetErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorKey: 0,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { instanceId } = this.props;
    console.error(`[WidgetErrorBoundary] Widget ${instanceId} failed:`, error, errorInfo);
    // TODO: integrar con servicio de logging marcado en componentDidCatch
  }

  handleRetry = () => {
    this.setState((prev) => ({ hasError: false, errorKey: prev.errorKey + 1 }));
  };

  render() {
    const { hasError, errorKey } = this.state;
    const { children, instanceId, errorMessage } = this.props;

    if (hasError) {
      return (
        <WidgetErrorState
          message={errorMessage}
          onRetry={this.handleRetry}
        />
      );
    }

    return <React.Fragment key={errorKey}>{children}</React.Fragment>;
  }
}

WidgetErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  instanceId: PropTypes.string,
  errorMessage: PropTypes.string,
};

WidgetErrorBoundary.defaultProps = {
  instanceId: 'unknown',
  errorMessage: WIDGET_GRID_COPY.errors.generic,
};

export default WidgetErrorBoundary;
